import axios from "axios";

const bugReportingToolURL = process.env.REACT_APP_BUG_REPORTING_TOOL_URL;
const bugReportingProxyURL = process.env.REACT_APP_BUG_REPORTING_PROXY_URL;

export async function getAllClients() {
  try {
    const response = await axios.get(
      `${bugReportingToolURL}client/getAllClients`
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching all clients:", error.message);

    throw error;
  }
}

export async function getBugDetails(bugID) {
  try {
    const response = await axios.get(`${bugReportingToolURL}bug/${bugID}`);

    return response.data;
  } catch (error) {
    console.error("Error fetching bug detail:", error.message);

    throw error;
  }
}

export async function getProjectByClientId(clientId) {
  try {
    const response = await axios.get(
      `${bugReportingToolURL}project/byClientId/${clientId}`
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching all clients:", error.message);

    throw error;
  }
}

export async function getProjectsByClientIdPaginated(clientId, page, size, includeJiraStatus = true) {
  try {
    const response = await axios.get(
      `${bugReportingToolURL}project/paginated/byClientId/${clientId}?page=${page}&size=${size}&includeJiraStatus=${includeJiraStatus}`
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching paginated projects:", error.message);

    throw error;
  }
}

export async function getAllProjectNames() {
  try {
    const response = await axios.get(`${bugReportingToolURL}project/names`);
    return response.data;
  } catch (error) {
    console.error("Error fetching project names:", error.message);
    throw error;
  }
}

export async function getProjectNamesByClientId(clientId) {
  try {
    const response = await axios.get(`${bugReportingToolURL}project/names/client/${clientId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching project names by client ID:", error.message);
    throw error;
  }
}

export async function getProjectById(projectId) {
  try {
    const response = await axios.get(`${bugReportingToolURL}project/${projectId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching project by ID:", error.message);
    throw error;
  }
}

export async function getBugSummary() {
  try {
    const response = await axios.get(`${bugReportingToolURL}bug_summary`);

    return response.data;
  } catch (error) {
    console.error("Error fetching all clients:", error.message);

    throw error;
  }
}

export async function getFeatureByProjId(projId) {
  try {
    const response = await axios.get(
      `${bugReportingToolURL}feature/byProject/${projId}`
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching all clients:", error.message);

    throw error;
  }
}

export async function getFeatureForDemo() {
  try {
    const response = await axios.get(`${bugReportingToolURL}feature`);

    return response.data;
  } catch (error) {
    console.error("Error fetching all clients:", error.message);

    throw error;
  }
}

export async function getBugsByProjId(projId) {
  try {
    const response = await axios.get(
      `${bugReportingToolURL}bug/getAllBugsByProject/${projId}`
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching all clients:", error.message);

    throw error;
  }
}

export async function getBugsByProjectAndCreatedBy(projectId, username) {
  try {
    const response = await axios.get(
      `${bugReportingToolURL}bug/getBugsByProject/${projectId}/createdBy/${username}`
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching bugs by project and created by user:", error.message);

    throw error;
  }
}

export async function deleteBugById(id, isPermanentDelete = false) {
  try {
    // Use different endpoints based on whether it's a permanent delete or not
    const endpoint = isPermanentDelete 
      ? `${bugReportingToolURL}bug/${id}/permanent`
      : `${bugReportingToolURL}bug/${id}`;
      
    const response = await axios.delete(endpoint);

    return response.data;
  } catch (error) {
    console.error("Error deleting bug:", error.message);

    throw error;
  }
}

export async function getRightDropdownBug() {
  try {
    const response = await axios.get(`${bugReportingToolURL}dropdowns`);

    return response.data;
  } catch (error) {
    console.error("Error fetching all clients:", error.message);

    throw error;
  }
}

export async function getAllGuidelinesWcag(projId) {
  try {
    const response = await axios.get(
      `${bugReportingToolURL}project/guidelines/${projId}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching all clients:", error.message);

    throw error;
  }
}

export async function getDashboardByProjId(projId) {
  try {
    const response = await axios.get(
      `${bugReportingToolURL}dashboard?projectId=${projId}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching dashboard data:", error.message);
    // Return default empty dashboard structure instead of throwing the error
    // This allows the UI to render with empty data instead of crashing
    return {
      projectId: projId,
      projectName: "",
      guId: "",
      bugSummary: [],
      severityCountMap: {
        HIGH: 0,
        MEDIUM: 0,
        LOW: 0
      },
      featureBugCountMap: {},
      topFiveList: []
    };
  }
}
export async function getDashboardByProjGuid(projGuid) {
  try {
    const response = await axios.get(
      `${bugReportingToolURL}dashboard?projectGuid=${projGuid}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching dashboard data:", error.message);
    // Return default empty dashboard structure instead of throwing the error
    // This allows the UI to render with empty data instead of crashing
    return {
      projectId: null,
      projectName: "",
      guId: projGuid,
      bugSummary: [],
      severityCountMap: {
        HIGH: 0,
        MEDIUM: 0,
        LOW: 0
      },
      featureBugCountMap: {},
      topFiveList: []
    };
  }
}
export async function createClient(name) {
  try {
    const response = await axios.post(`${bugReportingToolURL}client`, {
      name: name,
    });

    return response.data;
  } catch (error) {
    console.error("Error creating client:", error.message);

    throw error;
  }
}

export async function createProject(projectData, clientId) {
  try {
    const {name, url, username, password} = projectData;
    const response = await axios.post(`${bugReportingToolURL}project`, {
      name,
      userName: username,
      password,
      url,
      clientId,
    });

    return response.data;
  } catch (error) {
    console.error("Error creating client:", error.message);

    throw error;
  }
}

export async function createBug(payload) {
  try {
    const response = await axios.post(`${bugReportingToolURL}bug`, payload);

    return response.data;
  } catch (error) {
    console.error("Error creating bug:", error.message);

    throw error;
  }
}
export async function uploadScreenshot(screenshotFile, bugID) {
  try {
    const formData = new FormData();
    screenshotFile.map((screenshot, index) =>
      formData.append("file", screenshot)
    );
    const response = await axios.post(
      `${bugReportingToolURL}bug/upload/${bugID}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error uploading screenshot:", error.message);
    throw error;
  }
}

export async function createFeature(payload, projID) {
  try {
    const response = await axios.post(
      `${bugReportingToolURL}feature/${projID}`,
      payload
    );

    return response.data;
  } catch (error) {
    console.error("Error creating feature:", error.message);

    throw error;
  }
}

export async function modifyBug(payload, bugID) {
  try {
    const response = await axios.put(
      `${bugReportingToolURL}bug/${bugID}`,
      payload
    );

    return response.data;
  } catch (error) {
    console.error("Error modifying bug:", error.message);

    throw error;
  }
}

export async function guidelinesWcagPatch(projId, payload) {
  try {
    const response = await axios.put(
      `${bugReportingToolURL}project/${projId}`,
      payload
    );

    return response.data;
  } catch (error) {
    console.error("Error modifying bug:", error.message);

    throw error;
  }
}

export async function getSubtasksByProjectName(projectName) {
  try {
    const response = await axios.get(
      `${bugReportingToolURL}subtasks/epic/${projectName}`
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching subtasks:", error.message);

    throw error;
  }
}

export async function getBugsBySubtask(subtaskId) {
  try {
    const response = await axios.get(
      `${bugReportingToolURL}bug/getAllBugsBySubtask/${subtaskId}`
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching bugs by subtask:", error.message);

    throw error;
  }
}

export async function getAllBugsByProject(projectId) {
  try {
    const response = await axios.get(
      `${bugReportingToolURL}bug/getAllBugsByProject/${projectId}`
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching all bugs by project (including deleted):", error.message);

    throw error;
  }
}

export async function updateSubtaskStatus(subtaskKey, newStatus) {
  try {
    const response = await axios.put(
      `${bugReportingToolURL}subtasks/${subtaskKey}/status`,
      { status: newStatus }
    );

    return response.data;
  } catch (error) {
    console.error("Error updating subtask status:", error.message);

    throw error;
  }
}

// Project status is included in the project data from getProjectByClientId API

export async function updateProjectTaskStatus(epicKey, newStatus) {
  try {
    const response = await axios.put(
      `${bugReportingToolURL}tasks/jira/epic/${epicKey}/status`,
      { status: newStatus }
    );

    return response.data;
  } catch (error) {
    console.error("Error updating project task status:", error.message);

    throw error;
  }
}


export async function getTasksByProjectRange(projectId, startRow, endRow) {
  try {
    const response = await axios.get(
      `${bugReportingToolURL}tasks/project/${projectId}/range?startRow=${startRow}&endRow=${endRow}`
    );
    
    return response.data;
  } catch (error) {
    console.error("Error fetching tasks by range:", error.message);
    throw error;
  }
}

// Proxy service functions
export function convertToProxyUrl(originalUrl) {
  try {
    console.log("Converting URL to proxy URL:", originalUrl);

    if (!originalUrl) {
      console.warn("No URL provided for proxy conversion");
      return originalUrl;
    }

    // If it's already a proxy URL, use it as-is
    if (
      originalUrl.startsWith(`${bugReportingProxyURL}proxy/`) ||
      originalUrl.startsWith(`${bugReportingProxyURL}bento`)
    ) {
      console.log("URL is already proxied:", originalUrl);
      return originalUrl;
    }

    // For Bento URLs, use our dedicated Bento route 
    if (originalUrl.includes("bento.mheducation.com")) {
      // Extract aiId from the original URL
      let aiId = "";
      const aiIdMatch = originalUrl.match(/aiId=([^&;#]+)/);
      if (aiIdMatch && aiIdMatch[1]) {
        aiId = aiIdMatch[1];
        console.log("Extracted aiId:", aiId);
      }
      
      // Use the /bento endpoint from the ProxyController with the extracted aiId
      const proxyUrl = `${bugReportingProxyURL}bento#/aipreview;aiId=${aiId}`;
      console.log("Converted Bento URL to:", proxyUrl);
      return proxyUrl;
    }

    // For all other external URLs, use the proxy endpoint
    let cleanUrl = originalUrl.replace(/^https?:\/\//, "");
    // Use the /proxy/ endpoint from the ProxyController
    const proxyUrl = `${bugReportingProxyURL}proxy/${cleanUrl}`;
    console.log("Converted external URL to:", proxyUrl);

    return proxyUrl;
  } catch (error) {
    console.error("Error converting URL:", error);
    return originalUrl;
  }
}

export async function checkProxyServer() {
  try {
    // Use the health endpoint from the ProxyController
    const response = await axios.get("/");
    console.log("Proxy server is running ✓", response.data);
    return { 
      isRunning: true, 
      message: '✅ Proxy server detected<br>Ready to load content.' 
    };
  } catch (error) {
    console.warn("Proxy server not detected:", error);
    // Try the API health endpoint as fallback
    try {
      const apiResponse = await axios.get(`${bugReportingProxyURL}health`);
      console.log("API server is running ✓", apiResponse.data);
      return { 
        isRunning: true, 
        message: '✅ API server detected<br>Ready to load content.' 
      };
    } catch (apiError) {
      return { 
        isRunning: false, 
        message: "⚠️ Proxy server not running<br>Please start the proxy server first, then refresh this page." 
      };
    }
  }
}

// Test if a proxy URL is accessible
export async function testProxyUrl(url) {
  try {
    console.log("Testing proxy URL access:", url);
    const response = await axios.head(url);
    console.log("Proxy test response:", response.status);
    return response.ok || response.status === 200;
  } catch (error) {
    console.error("Proxy test failed:", error);
    return false;
  }
}

// Get bug count statistics for a project (valid, invalid, total)
export async function getBugCountsByProject(projectId) {
  try {
    const response = await axios.get(
      `${bugReportingToolURL}bug/project/${projectId}/bug-counts`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching bug counts:", error.message);
    // Return default values if the API fails
    return {
      validBugsCount: 0,
      invalidBugsCount: 0,
      totalBugsCount: 0
    };
  }
}

// Get bugs statistics by user for a project
export async function getBugsStatsByUser(projectId) {
  try {
    // Use the new API endpoint that returns valid and invalid bug counts per user
    const response = await axios.get(
      `${bugReportingToolURL}bug/project/${projectId}/bugs-by-user`
    );
    
    // Transform response to match the format expected by the component
    return response.data.map(user => ({
      userName: user.username,
      validBugsCount: user.validBugsCount,
      invalidBugsCount: user.invalidBugsCount,
      totalBugsCount: user.totalBugsCount
    }));
    
  } catch (error) {
    console.error("Error fetching bugs stats by user:", error.message);
    
    // Return mock data as fallback
    const mockData = [
      { userName: "John Doe", validBugsCount: 10, invalidBugsCount: 3, totalBugsCount: 13 },
      { userName: "Jane Smith", validBugsCount: 15, invalidBugsCount: 8, totalBugsCount: 23 },
      { userName: "Mike Johnson", validBugsCount: 5, invalidBugsCount: 2, totalBugsCount: 7 },
      { userName: "Sarah Wilson", validBugsCount: 12, invalidBugsCount: 5, totalBugsCount: 17 },
      { userName: "David Brown", validBugsCount: 8, invalidBugsCount: 4, totalBugsCount: 12 }
    ];
    
    return mockData;
  }
}

// Time tracking API functions
export async function logUserTime(timeEntryData) {
  try {
    const response = await axios.post(
      `${bugReportingToolURL}time-tracking/log`,
      timeEntryData
    );
    
    return response.data;
  } catch (error) {
    console.error("Error logging time entry:", error.message);
    throw error;
  }
}

// Download time report for a project as CSV
export function getTimeReportDownloadUrl(projectId) {
  return `${bugReportingToolURL}time-tracking/project/${projectId}/user-question-time-report`;
}
